<script setup lang="ts">
  import Button from '@leaflink/stash/Button.vue';
  import Logo from '@leaflink/stash/Logo.vue';
  import Modal from '@leaflink/stash/Modal.vue';
  import Textarea from '@leaflink/stash/Textarea.vue';
  import { storeToRefs } from 'pinia';
  import { computed, ref } from 'vue';
  import { I18nT } from 'vue-i18n';

  import { useCompanyStore } from '@/piniaStores/company/company.store';
  import i18n from '@/plugins/i18n';

  const emits = defineEmits<{
    (e: 'submit', text: string): void;
    (e: 'back'): void;
  }>();

  const { activeCompany } = storeToRefs(useCompanyStore());

  const learnMoreUrl = computed(() =>
    activeCompany.value?.seller
      ? i18n.t('paymentOnSellThroughEnrollment.sellerLearnMoreUrl')
      : i18n.t('paymentOnSellThroughEnrollment.buyerLearnMoreUrl'),
  );

  const notInterestedReason = ref('');
</script>
<template>
  <Modal :title="i18n.t('paymentOnSellThroughEnrollment.notInterestedModal.title')">
    <div class="tw-min-h-[487px]">
      <Logo brand="post" variant="lockup" class="tw-mb-6" />
      <h2 class="tw-mb-3">{{ i18n.t('paymentOnSellThroughEnrollment.notInterestedModal.subtitle') }}</h2>
      <I18nT
        keypath="paymentOnSellThroughEnrollment.notInterestedModal.mainContent"
        scope="global"
        tag="div"
        class="tw-mb-6 tw-text-base"
      >
        <template #link>
          <a :href="learnMoreUrl" target="_blank">{{ i18n.t('paymentOnSellThroughEnrollment.descriptionLinkCopy') }}</a>
        </template>
      </I18nT>
      <Textarea
        v-model="notInterestedReason"
        :label="i18n.t('paymentOnSellThroughEnrollment.notInterestedModal.comments')"
        data-test="not-interested-reason"
        class="tw-mb-3 tw-text-sm"
        :rows="8"
        :maxlength="280"
      />
      <div>{{ i18n.t('paymentOnSellThroughEnrollment.notInterestedModal.characterLimit') }}</div>
    </div>
    <template #actions>
      <Button secondary @click="emits('back')">{{
        i18n.t('paymentOnSellThroughEnrollment.notInterestedModal.goBack')
      }}</Button>
      <Button @click="() => emits('submit', notInterestedReason)">{{ i18n.t('common.submit') }}</Button>
    </template>
  </Modal>
</template>
